export default "__VITE_ASSET__299831ce__"